import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ISubscriptionInfo } from '../../../../ts/models/ISubscriptionInfo';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { DateTimeCell, OverridableDateTimeCell } from './DateTimeCells';
import { CreateCellText } from './PlainTextAndNumberCells';

export function SubscriptionNextUpdateDescriptionCell(): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function SubscriptionNextUpdateDescriptionCell(props: BodyCell.Props) {
        const row = props.row;
        const subscription = row.data as ISubscriptionInfo;
        if (subscription.refreshExtractTriggered != null
            && subscription.refreshExtractTriggered) {
          return CreateCellText(Messages.subscriptionOnExtractRefreshNextUpdate());
        } else if (FeatureFlags.suspendSubscriptions) {
          return OverridableDateTimeCell('runNextAt', 'suspended', Messages.disabled())(props);
        } else {
          return DateTimeCell('runNextAt', Messages.disabled())(props);
        }
      }
  );
}
